"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.array.for-each");require("core-js/modules/es.array.some");exports.__esModule = true;exports.prepareArgs = prepareArgs;exports.calcMinMaxObj = calcMinMaxObj;exports.checkIsFilled = void 0;

var _is = require("../../is");


var _convert = _interopRequireDefault(require("../convert"));
var _consts = _interopRequireDefault(require("../consts"));
var _getters = require("../getters");
var _obj = require("../../obj");
var _innerUtils = require("../innerUtils");









// type ArgsType = {|
//   date?: FullDateType | null,
//   segments?: { date?: boolean, time?: boolean, seconds?: boolean },
// |}



function convertHasSegments(objIn) {
  var result = { date: true, time: true, seconds: true };
  if ((0, _is.isObj)(objIn)) {
    var obj = objIn;
    ['date', 'time', 'seconds'].
    forEach(function (segment) {
      if ((0, _is.isBool)(obj[segment])) {
        result[segment] = obj[segment];
      }
    });
  }
  return result;
}
function convertDate(dateIn) {
  var date = (0, _getters.getNow)();
  var hasDate = false;
  if (!(0, _is.isNull)(dateIn) && !(0, _is.isUndef)(dateIn)) {
    var maybeDate = _convert.default.fromWhatever(dateIn);
    if (maybeDate !== null) {
      date = maybeDate;
      hasDate = true;
    }
  }

  return { date: date, hasDate: hasDate };

}
function prepareArgs(argsIn) {
  var args = (0, _obj.castObj)(argsIn);var _convertDate =
  convertDate(args.date),date = _convertDate.date,hasDate = _convertDate.hasDate;
  return {
    date: date,
    hasDate: hasDate,
    hasSegments: convertHasSegments(args.hasSegments) };

}


var checkIsFilled = function checkIsFilled(inputed, hasSegments) {
  if (hasSegments.date &&
  _consts.default.dmyKeys.
  some(function (partNameChar) {return !(0, _is.isNum)(inputed.date[partNameChar]);}))
  return false;

  if (hasSegments.time &&
  ['h', 'm'].some(function (partNameChar) {return !(0, _is.isNum)(inputed.time[partNameChar]);}))
  {
    return false;
  }

  if (hasSegments.seconds && !(0, _is.isNum)(inputed.time.s)) {
    return false;
  }

  return true;
};exports.checkIsFilled = checkIsFilled;


function clearAllPartsFrom(partNameInd, keys, dateObj) {var
  length = keys.length;
  if (partNameInd >= length) return;
  for (var ind = partNameInd; ind < length; ind++) {
    (0, _innerUtils.setToDateObj)(dateObj, keys[ind], null);
  }
}



// eslint-disable-next-line max-params
function calcMinMaxObj(
inputedDateObj,
minMaxDateObj,
minMaxDateObjForInputed,
hasSegments)
// target: 'min' | 'max',
{

  var keysToCompare = [];
  if (hasSegments.date) {keysToCompare.push.apply(keysToCompare, _consts.default.dmyKeys);}
  if (hasSegments.time) {keysToCompare.push('h', 'm');}
  if (hasSegments.seconds) {keysToCompare.push('s');}



  var firstKey = keysToCompare[0];
  (0, _innerUtils.setToDateObj)(minMaxDateObjForInputed, firstKey, (0, _innerUtils.getFromDateObj)(minMaxDateObj, firstKey));

  for (var i = 0; i < keysToCompare.length - 1; i++) {
    var partName = keysToCompare[i];
    var valInMinMax = (0, _innerUtils.getFromDateObj)(minMaxDateObj, partName);
    var valInInputed = (0, _innerUtils.getFromDateObj)(inputedDateObj, partName);
    var valInMinMaxForInputed = (0, _innerUtils.getFromDateObj)(minMaxDateObjForInputed, partName);

    if ((0, _is.isNullSome)(valInMinMaxForInputed, valInMinMax, valInInputed)) {
      clearAllPartsFrom(i + 1, keysToCompare, minMaxDateObjForInputed);
      break;
    }

    var isPartOnSide = valInInputed === valInMinMax;
    var nextPartKey = keysToCompare[i + 1];
    var nextPartVal = isPartOnSide ? (0, _innerUtils.getFromDateObj)(minMaxDateObj, nextPartKey) : null;

    (0, _innerUtils.setToDateObj)(minMaxDateObjForInputed, nextPartKey, nextPartVal);

  }
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/TimeInputs/utils.js
// module id = 624
// module chunks = 0